<template>
    <el-tabs v-model="activeActiveCom" type="card" @tab-click="handleTabs">
        <el-tab-pane v-for="item in tabs" :key="item.name" :name="item.name" :label="$t(item.label)"></el-tab-pane>
    </el-tabs>
</template>

<script>
export default {
    props: ['activeCom', 'tabs'],
    computed: {
        activeActiveCom: {
            get: function () {
                return this.activeCom
            },
            set: function (val) {
                this.$emit('update:activeCom', val)
            }
        }
    },
    methods: {
        handleTabs({ name }) {
            this.$emit('handleTabs', name)
        }
    }
}
</script>

<style>
</style>